import axios from 'axios'
import retry from './interceptors/retry'
import requestWithToken from './interceptors/requestWithToken'
import handleBusiness from './interceptors/business'
import requestWithBrand from './interceptors/requestWithBrand'

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000,
  retryDelay: 500,
  retry: 3,
})

service.interceptors.request.use(...requestWithToken)
service.interceptors.request.use(...requestWithBrand)
service.interceptors.response.use(...retry)
service.interceptors.response.use(...handleBusiness)

export default service
